module.exports = __webpack_public_path__ + "img/icon-info-gris.f2d34ecc.svg";